import {
  FacilityService,
  ProviderService
} from 'react-angle-dashboard-components'
import { CareService } from './care'

const BASE_URL = (window as any).runtimeConfig?.apiURL

export const providerService = new ProviderService(BASE_URL)
export const facilityService = new FacilityService(BASE_URL)
export const careService = new CareService(BASE_URL)
